import React, { useState } from "react";
import PropTypes from "prop-types";
import SubMenu from "./SubMenu";
import { menuDefsAdmin } from "./menuDefsAdmin";
import Person from "@material-ui/icons/Person";
import { makeStyles } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { Typography } from "@material-ui/core";
import { useNavigate } from "react-router";
import PowerSettingsNewRoundedIcon from "@material-ui/icons/PowerSettingsNewRounded";
import { logoutService } from "../api";
import { SESSION_SECURITY_ROLE_KEY, SESSION_USER_ID_KEY, USER_GENERIC_NAME } from "../utils/constants";

const useStyles = makeStyles((theme) => ({
  menu: {
    paddingTop: theme.spacing(2),
  },
  openedMenu: {
    "-webkit-transition": "width 0.3s ease-in-out",
    "-moz-transition": "width 0.3s ease-in-out",
    "-o-transition": "width 0.3s ease-in-out",
    transition: "width 0.3s ease-in-out",
    width: theme.spacing(32),
  },
  closedMenu: {
    "-webkit-transition": "width 0.3s ease-in-out",
    "-moz-transition": "width 0.3s ease-in-out",
    "-o-transition": "width 0.3s ease-in-out",
    transition: "width 0.3s ease-in-out",
    width: theme.spacing(6.5),
  },
  icon: {
    minWidth: theme.spacing(5),
  },
  sidebarIsOpen: {
    paddingLeft: theme.spacing(2),
    transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
  },
  sidebarIsClosed: {
    paddingLeft: theme.spacing(0),
    transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
  },
  highlightedMenu: {
    color: theme.palette.secondary.main + " !important",
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.secondary.main + " !important",
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

const CustomMenu = ({ open }) => {
  const classes = useStyles();
  const intl = useIntl();
  const navigate = useNavigate();

  const roles = JSON.parse(sessionStorage.getItem(SESSION_SECURITY_ROLE_KEY));
  const userAlias = sessionStorage.getItem(SESSION_USER_ID_KEY) || USER_GENERIC_NAME;

  const location = window.location.pathname.split("/")[3];

  const [state, setState] = useState({
    isMenuOpen: {},
  });

  const handleMenu = (idMenu) => {
    setState((state) => {
      let newState = { ...state };
      newState.isMenuOpen[idMenu] = !state.isMenuOpen[idMenu];
      return newState;
    });
  };

  const isMenuOpen = (state, idMenu) => {
    return state.isMenuOpen[idMenu];
  };

  const idMenu = (l1, l2 = "", l3 = "") => {
    return "" + l1 + "-" + l2 + "-" + l3;
  };

  const handleRedirect = (url) => {
    navigate(url);
  };

  const handleLogOut = () => {
    logoutService();
  };

  return (
    <div className={`${classes.menu} ${open ? classes.openedMenu : classes.closedMenu}`}>
      {menuDefsAdmin
        .map(
          (menuDef, i) =>
            roles.includes(menuDef.perms) &&
            (menuDef.url === undefined ? (
              <SubMenu
                classes={classes}
                location={location}
                key={idMenu(i)}
                handleToggle={() => handleMenu(idMenu(i))}
                isOpen={isMenuOpen(state, idMenu(i))}
                sidebarIsOpen={open}
                name={menuDef.name}
                icon={<menuDef.icon />}
              >
                {(menuDef.itemDefs || []).map(
                  (itemDef, n) =>
                    roles.includes(menuDef.perms) &&
                    (itemDef.url === undefined ? (
                      <SubMenu
                        classes={classes}
                        location={location}
                        key={idMenu(i, n)}
                        handleToggle={() => handleMenu(idMenu(i, n))}
                        isOpen={isMenuOpen(state, idMenu(i, n))}
                        sidebarIsOpen={open}
                        icon={<itemDef.icon />}
                        name={itemDef.name}
                      >
                        {(itemDef.subItemDefs || []).map(
                          (subItemDef, j) =>
                            roles.includes(menuDef.perms) && (
                              <MenuItem key={idMenu(i, n, j)} onClick={() => handleRedirect(subItemDef.url)}>
                                <ListItemIcon>
                                  <subItemDef.icon />
                                </ListItemIcon>
                                <Typography>{intl.formatMessage({ id: subItemDef.name })}</Typography>
                              </MenuItem>
                            ),
                        )}
                      </SubMenu>
                    ) : (
                      <MenuItem key={idMenu(i, n)} onClick={() => handleRedirect(itemDef.url)}>
                        <ListItemIcon>
                          <itemDef.icon />
                        </ListItemIcon>
                        <Typography>{intl.formatMessage({ id: itemDef.name })}</Typography>
                      </MenuItem>
                    )),
                )}
              </SubMenu>
            ) : (
              <MenuItem
                key={idMenu(i)}
                onClick={() => handleRedirect(menuDef.url)}
                className={!location ? classes.highlightedMenu : ""}
              >
                <ListItemIcon>
                  <menuDef.icon />
                </ListItemIcon>
                <Typography>{intl.formatMessage({ id: menuDef.name })}</Typography>
              </MenuItem>
            )),
        )
        .concat([
          <SubMenu
            classes={classes}
            location={location}
            key={idMenu("usr")}
            handleToggle={() => handleMenu(idMenu("usr"))}
            isOpen={isMenuOpen(state, idMenu("usr"))}
            sidebarIsOpen={open}
            name={userAlias}
            icon={<Person />}
            noTranslation={true}
          >
            <MenuItem key={idMenu("usr")} onClick={handleLogOut}>
              <ListItemIcon>
                <PowerSettingsNewRoundedIcon />
              </ListItemIcon>
              <Typography>{intl.formatMessage({ id: "ra.auth.logout" })}</Typography>
            </MenuItem>
          </SubMenu>,
        ])}
    </div>
  );
};

CustomMenu.propTypes = {
  onMenuClick: PropTypes.func,
  logout: PropTypes.object,
};

export default CustomMenu;
